import React, { useMemo } from 'react';
import useI18n from '@i18n';

import { IGetMotivationData } from '@api/types';
import apiHooks from '@apiHooks';

const { useMotivations } = apiHooks;

interface ILevelTooltip {
    handleModal: () => void;
}

const LevelTooltip: React.FC<ILevelTooltip> = ({ handleModal }) => {
    const { data } = useMotivations<IGetMotivationData>();
    const { t } = useI18n('Statistic');
    const { levels, currentLevel } = data;
    const levelInfo = useMemo(() => levels.find(level => level.number === currentLevel), [
        levels,
        currentLevel,
    ]);

    return (
        <div>
            <p className="pb-1">
                {t('Currently, you are at')}{' '}
                <span className="font-bold">{t('level n', { level: currentLevel })}</span>,{' '}
                {t('which means that')},{' '}
                <span className="font-bold">{t('over the past three months')} </span>
                {levelInfo.gmvLowerBound === 0 && levelInfo.gmvUpperBound !== 0 && (
                    <span className="font-bold">
                        {t('turnover to', { to: levelInfo.gmvUpperBound })}
                    </span>
                )}{' '}
                {levelInfo.gmvLowerBound !== 0 && levelInfo.gmvUpperBound === 0 && (
                    <span className="font-bold">
                        {t('turnover from', { from: levelInfo.gmvLowerBound })}
                    </span>
                )}{' '}
                {levelInfo.gmvLowerBound !== 0 && levelInfo.gmvUpperBound !== 0 && (
                    <span className="font-bold">
                        {t('turnover between border', {
                            from: levelInfo.gmvLowerBound,
                            to: levelInfo.gmvUpperBound,
                        })}
                    </span>
                )}
                . {t('The rate for non-affiliate products is')}{' '}
                <span className="font-bold">{currentLevel < 3 ? '0.008' : '0.2'}%</span>
            </p>
            <button
                onClick={handleModal}
                type="button"
                className="w-full font-bold underline bg-transparent text-[14px] hover:text-blueGray-600 h-40px"
            >
                {t('Show possible conditions')}
            </button>
        </div>
    );
};

export default LevelTooltip;
